import * as Scrivito from 'scrivito';
import { ColumnWidget, ColumnWidgetClass } from './column-widget-class';
import React from 'react';
import { ColumnWidgetAttributes, ColumnWidgetBackgroundColor } from './column-widget-definitions';
import styles from './column-widget.module.scss';
import classNames from 'classnames';
import { spacingClassName } from '../../utils/scrivito/spacing-definitions';

export const ColumnWidgetComponent: React.FC<{ widget: ColumnWidget }> = ({ widget }) => {
  const background = widget.get(ColumnWidgetAttributes.BACKGROUND_COLOR);

  return (
    <Scrivito.WidgetTag>
      <Scrivito.ContentTag
        className={classNames('Column', styles.ColumnWidget, spacingClassName(widget), {
          [styles.ColumnWidgetLeftGray]: background === ColumnWidgetBackgroundColor.LEFT_GRAY,
          [styles.ColumnWidgetRightGray]: background === ColumnWidgetBackgroundColor.RIGHT_GRAY,
          [styles.ColumnWidgetGray]: background === ColumnWidgetBackgroundColor.GRAY,
        })}
        content={widget}
        attribute={ColumnWidgetAttributes.ELEMENTS}
      />
    </Scrivito.WidgetTag>
  );
};

Scrivito.provideComponent(ColumnWidgetClass, ColumnWidgetComponent);
